<template>
  <div class="journey-progress progress">
    <div class="bar">
      <span class="segment-wrapper"
      :class="{visible: isVisible(index), clickable: interactive}"
      v-for="step, index in steps"
      :key="index"
      @click="() => {emitIndex(index)}">
        <span
        class="segment complete"
        :style="{width: getPercentComplete(index) + '%'}">
        </span>
        <span
        class="segment incomplete"
        :style="{width: getPercentIncomplete(index) + '%'}">
        </span>
      </span>
    </div>
    <div class="count">{{ $t('message.x-of-y-steps-complete', [completeCount, steps.length]) }}</div>
  </div>
</template>

<style lang="less" scoped>
@import "./shared.less";
.journey-progress {
  .bar {
    width: 100%;
    display: flex;
  }
  .segment-wrapper {
    display: flex;
    width: 100%;
    width: -moz-available;
    width: -webkit-fill-available;
    width: fill-available;
    margin-bottom: 5px;
    background: rgba(255,255,255,0.3);
    border: 0px solid transparent;
    border-radius: 6px;
    -webkit-transition: background 0.2s ease-out;
    transition: background 0.2s ease-out;
    &:not(:first-of-type) {
      margin-left: 8px;
    }
    &.clickable {
      cursor: pointer;
      &:hover{
        background: rgba(255,255,255,0.5);
      }
    }
    .segment {
      height: 6px;
      border-radius: 5px;
      &.complete {
        opacity: 0.7;
        background: white;
      }
    }
    &.visible {
      background: #1E86FF;
      &:hover{
        background: #1E86FF;
      }
    }
  }
  .count {
    color: rgba(255,255,255,0.6);
  }
}
</style>

<script>
export default {
  props: {
    steps: {
      type: Array
    },
    visible: {
      type: Array
    },
    interactive: { // Can a user hover / click on segments
      type: Boolean,
      default: false
    }
  },
  computed: {
    completeCount () {
      return this.steps.filter((step)=>{
        return step.task.total === step.task.complete;
      }).length;
    }
  },
  methods: {
    emitIndex(index) {
      if (this.interactive) {
        this.$emit('select', index);
      }
    },
    getPercentComplete(index) {
      let task = this.steps[index].task;
      return Math.round((task.complete / task.total) * 100);
    },
    getPercentIncomplete(index) {
      return 100 - this.getPercentComplete(index);
    },
    isVisible(index) {
      return this.visible && this.visible.includes(index);
    }
  }
}
</script>
